import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/free-solid-svg-icons'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { useRouter } from 'next/navigation'
import { useTranslation } from '@/localization/useTranslation'

import classes from './styles.module.scss'
import { useQueryState } from 'nuqs'
import { NAVBAR_THEMES } from '@/constants'
import { NAVBAR_ACTIONS, NavbarAction } from '@/constants/navbar'

interface MinimalNavbarProps {
  icon?: IconDefinition
  label?: string
  onClick?: () => void
  /** Absent = home, the historic behaviour of every minimal scene. */
  action?: NavbarAction
}

export const MinimalNavbar = (props: MinimalNavbarProps) => {
  const { icon, label, onClick, action } = props
  const { t } = useTranslation()
  const router = useRouter()
  const [authFormType] = useQueryState('form')
  const themeType = (authFormType || 'default') as keyof typeof NAVBAR_THEMES
  const theme = NAVBAR_THEMES[themeType] || NAVBAR_THEMES.default

  const isBack = action === NAVBAR_ACTIONS.back

  const handleClick = () => {
    if (onClick) {
      onClick()
      return
    }

    // A shared link or a fresh tab has nothing to go back to, and this link is
    // the scene's only way out.
    if (isBack && window.history.length > 1) {
      router.back()
      return
    }

    router.push('/')
  }

  return (
    <nav className={classes.minimal_navbar} style={{ backgroundColor: theme.backgroundColor }}>
      <button type='button' className={classes.item} onClick={handleClick}>
        <FontAwesomeIcon icon={icon || faArrowLeft} />
        <span>{label || t(isBack ? 'Back' : 'Back to Home')}</span>
      </button>
    </nav>
  )
}
